interface ScarcitySectionProps {
  batchName: string
  unitsRemaining: number
  totalUnits: number
  urgencyMessage: string
}

export default function ScarcitySection({
  batchName,
  unitsRemaining,
  totalUnits,
  urgencyMessage
}: ScarcitySectionProps) {
  const unitsSold = totalUnits - unitsRemaining
  const percentageClaimed = (unitsSold / totalUnits) * 100

  return (
    <section className="py-12 sm:py-16 md:py-20 px-4 sm:px-6 reveal">
      <div className="max-w-4xl mx-auto">
        <div className="glass-panel rounded-xl sm:rounded-2xl p-6 sm:p-8 md:p-12 grid-border">
          
          {/* Header */}
          <div className="text-center mb-6 sm:mb-8">
            <div className="mono-data text-xs sm:text-sm uppercase tracking-widest text-foreground/60 mb-2">
              {batchName}
            </div>
            <h2 className="playfair-header text-3xl sm:text-4xl md:text-5xl text-foreground mb-3 sm:mb-4">
              The First 1,000.
            </h2>
          </div>

          {/* Stats Grid */}
          <div className="grid md:grid-cols-2 gap-4 sm:gap-6 mb-6 sm:mb-8">
            <div className="text-center p-4 sm:p-6 bg-card/50 rounded-lg sm:rounded-xl grid-border">
              <div className="mono-data text-xs sm:text-sm uppercase tracking-wider text-foreground/60 mb-2">
                UNITS SOLD
              </div>
              <div className="mono-data text-4xl sm:text-5xl font-bold text-foreground">
                {unitsSold}/{totalUnits}
              </div>
              <div className="mono-data text-xs sm:text-sm text-foreground/70 mt-2">
                UNITS CLAIMED
              </div>
            </div>
            
            <div className="text-center p-4 sm:p-6 bg-card/50 rounded-lg sm:rounded-xl grid-border">
              <div className="mono-data text-xs sm:text-sm uppercase tracking-wider text-foreground/60 mb-2">
                REMAINING
              </div>
              <div className="mono-data text-4xl sm:text-5xl font-bold text-primary">
                {unitsRemaining}
              </div>
              <div className="mono-data text-xs sm:text-sm text-foreground/70 mt-2">
                UNITS AVAILABLE
              </div>
            </div>
          </div>

          {/* Progress Bar */}
          <div className="mb-4 sm:mb-6">
            <div className="flex justify-between items-center mb-2">
              <span className="mono-data text-xs text-foreground/60">BATCH COMPLETION</span>
              <span className="mono-data text-xs font-bold text-foreground">{percentageClaimed.toFixed(1)}%</span>
            </div>
            <div className="scarcity-bar" />
          </div>

          {/* Urgency Message */}
          <div className="text-center p-4 sm:p-6 bg-destructive/10 rounded-lg sm:rounded-xl grid-border border-destructive/30">
            <div className="mono-data text-xs sm:text-sm uppercase tracking-wider text-destructive font-bold mb-2">
              ⚠ CRITICAL
            </div>
            <p className="text-sm sm:text-base text-foreground/80 leading-relaxed">
              {urgencyMessage}
            </p>
          </div>

        </div>
      </div>
    </section>
  )
}